<template>
  <div class="preview-res" :style="`width: ${size}px; height: ${size}px;`">
    <img :src="src" :width="size" :height="size" />
    <span v-if="isVideo(originalFileName)">Video</span>
  </div>
</template>
<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
    originalFileName: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 120,
    },
  },
  data() {
    return {}
  },
  methods: {
    isVideo(url) {
      return /\.(mp4|webm|ogg|mov)$/i.test(url)
    },
  },
}
</script>
<style scoped>
.preview-res {
  position: relative;
}

.preview-res > img {
  object-fit: contain;
}

.preview-res > span {
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 4px 10px;
  border-radius: 5px;
}
</style>
